import { createInquiryUrl, type InquiryLanguage } from '@zep-us/cs/inquiry-url';
import { type SupportedCountryCode } from '@zep-us/i18n';

const QUIZ_INQUIRY_WORKFLOW_ID = '6a15404bc6428c0f6ed1a7c4';

const QUIZ_INQUIRY_NODE_IDS = {
  plan: '74d2d99b-5541-4866-bfb3-a647034d06ea',
  planExtension: '22cc4b0c-432b-4c41-843e-45ddf2c801e5',
  payment: '163fee95-5ab0-4b67-88b5-0476a0734e52',
} as const;

export type QuizInquiryTarget = keyof typeof QUIZ_INQUIRY_NODE_IDS;

/**
 * 채널톡 외 국가별 문의 링크. 이번 마이그레이션에서는 기존 동작을 유지한다.
 */
const EXTERNAL_INQUIRY_LINKS: Partial<Record<SupportedCountryCode, string>> = {
  TH: 'https://lin.ee/X46KGYN', // 태국
  ID: 'https://wa.me/6285179812262', // 인도네시아
  MY: 'https://wa.me/6285179812262', // 말레이시아
};

const getInquiryLanguage = (countryCode?: string | null): InquiryLanguage => {
  const normalizedCountryCode = countryCode?.toUpperCase();
  if (normalizedCountryCode === 'KR') return 'ko';
  if (normalizedCountryCode === 'JP') return 'ja';
  return 'en';
};

/**
 * 사용자의 국가와 문의 목적에 맞는 링크를 반환한다.
 * 기존 LINE/WhatsApp 대상 국가는 유지하고, 나머지는 Quiz 축약 워크플로우로 연결한다.
 * @param countryCode - 사용자의 국가 코드
 * @param target - 워크플로우에서 바로 열 문의 단계
 */
export const getInquiryLinkByCountryCode = (
  countryCode?: SupportedCountryCode | string | null,
  target: QuizInquiryTarget = 'plan',
): string => {
  const normalizedCountryCode = countryCode?.toUpperCase() as
    | SupportedCountryCode
    | undefined;
  const externalLink = normalizedCountryCode
    ? EXTERNAL_INQUIRY_LINKS[normalizedCountryCode]
    : undefined;

  if (externalLink) return externalLink;

  return createInquiryUrl({
    service: 'quiz',
    workflowId: QUIZ_INQUIRY_WORKFLOW_ID,
    nodeId: QUIZ_INQUIRY_NODE_IDS[target],
    lang: getInquiryLanguage(normalizedCountryCode),
  });
};
